module.exports = __webpack_public_path__ + "img/Diego_Plascencia.da6a6ded.jpg";